import { bl_fi_fixed_asset_register_attachment_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class AssetRegisterAttachmentModel extends BaseContainerModel {
  bl_fi_fixed_asset_register_attachment: bl_fi_fixed_asset_register_attachment_RowClass = new bl_fi_fixed_asset_register_attachment_RowClass();
}

export class AssetRegisterAttachmentQueryCriteria {
  offset: number;
  limit: number;
  orderBy: string;
  order: string;
  keyword: string;
  txn_type: string;
  code: string;
  name: string;
  descr: string;
  status: string;
  param_code: string;
  value_string: string;
}
